import React from "react";
import PropTypes from "prop-types";
import horizontalStyles from "./layouts/horizontal-v1/HorizontalProductLayout.module.css";
import verticalStyles from "./layouts/vertical-v1/VerticalProductLayout.module.css";
import cardStyles from "./CatalogProductCardSkeleton.module.css";

export default function CatalogProductCardSkeleton({
  isHorizontal = false,
  isMobile = false,
  layoutProfile = "recommendation",
  mobileCardDensity = "single",
  imageSlotHeight = 132,
  imageColStyle,
}) {
  const isAiUpsell = layoutProfile === "ai-upsell";
  const isTwin = mobileCardDensity === "twin" && isMobile;

  if (isHorizontal) {
    return (
      <article
        className={`${horizontalStyles.root} ${
          isAiUpsell ? horizontalStyles.aiUpsell : ""
        }`.trim()}
        aria-hidden
      >
        <div className={horizontalStyles.mainRow}>
          <div className={horizontalStyles.imageCol} style={imageColStyle}>
            <div
              className={isAiUpsell ? cardStyles.imageShimmerAi : cardStyles.imageShimmer}
              style={{ height: imageSlotHeight, minHeight: imageSlotHeight }}
            />
          </div>
          <div className={horizontalStyles.metaCol}>
            <span className={`${cardStyles.line} ${cardStyles.lineWide}`} />
            <span className={`${cardStyles.line} ${cardStyles.lineMid}`} />
            {isAiUpsell ? (
              <>
                <span className={`${cardStyles.line} ${cardStyles.lineShort}`} />
                <span
                  className={`${cardStyles.block} ${
                    isMobile ? cardStyles.blockCompact : ""
                  }`.trim()}
                />
                <span
                  className={`${cardStyles.block} ${
                    isMobile ? cardStyles.blockCompact : ""
                  }`.trim()}
                />
              </>
            ) : (
              <span
                className={`${cardStyles.button} ${
                  isMobile ? cardStyles.buttonCompact : ""
                }`.trim()}
              />
            )}
          </div>
        </div>
      </article>
    );
  }

  return (
    <article
      className={`${verticalStyles.root} ${isTwin ? verticalStyles.mobileTwin : ""} ${
        isMobile ? verticalStyles.mobile : ""
      }`.trim()}
      aria-hidden
    >
      <div
        className={cardStyles.imageShimmer}
        style={{ height: imageSlotHeight, minHeight: imageSlotHeight }}
      />
      <div className={cardStyles.meta}>
        <span className={`${cardStyles.line} ${cardStyles.lineWide}`} />
        <span className={`${cardStyles.line} ${cardStyles.lineMid}`} />
        {!isTwin ? (
          <span className={`${cardStyles.line} ${cardStyles.lineShort}`} />
        ) : null}
        <span
          className={`${cardStyles.button} ${
            isTwin || isMobile ? cardStyles.buttonCompact : ""
          }`.trim()}
        />
      </div>
    </article>
  );
}

CatalogProductCardSkeleton.propTypes = {
  isHorizontal: PropTypes.bool,
  isMobile: PropTypes.bool,
  layoutProfile: PropTypes.oneOf(["recommendation", "ai-upsell"]),
  mobileCardDensity: PropTypes.oneOf(["single", "twin"]),
  imageSlotHeight: PropTypes.number,
  imageColStyle: PropTypes.object,
};
